const list = [{
		img: require('@/assets/image/housing/chang.png'),
	},
	{
		img: require('@/assets/image/housing/chang.png'),
	},
	{
		img: require('@/assets/image/housing/chang.png'),
	},
	{
		img: require('@/assets/image/housing/chang.png'),
	}
]
const apartment = [{
		img: require('@/assets/image/housing/g-1.png'),
		name: "床"
	},
	{
		img: require('@/assets/image/housing/g-2.png'),
		name: "衣柜"
	},
	{
		img: require('@/assets/image/housing/g-3.png'),
		name: "书桌"
	},
	{
		img: require('@/assets/image/housing/g-4.png'),
		name: "椅子"
	},
	{
		img: require('@/assets/image/housing/g-5.png'),
		name: "餐桌"
	},
	{
		img: require('@/assets/image/housing/g-6.png'),
		name: "餐椅"
	},
	{
		img: require('@/assets/image/housing/g-7.png'),
		name: "鞋柜"
	},
	{
		img: require('@/assets/image/housing/g-8.png'),
		name: "热水器"
	},
	{
			img: require('@/assets/image/housing/g-9.png'),
			name: "冰箱"
		},
		{
			img: require('@/assets/image/housing/g-10.png'),
			name: "吸烟机"
		},
		{
			img: require('@/assets/image/housing/g-11.png'),
			name: "炉具"
		},
		{
			img: require('@/assets/image/housing/g-12.png'),
			name: "洗衣机"
		},
		{
			img: require('@/assets/image/housing/g-13.png'),
			name: "沙发"
		},
		{
			img: require('@/assets/image/housing/g-14.png'),
			name: "智能门锁"
		},
		{
			img: require('@/assets/image/housing/g-15.png'),
			name: "电视"
		},
		{
			img: require('@/assets/image/housing/g-16.png'),
			name: "茶几"
		}
]

const room = [{
		img: require('@/assets/image/housing/l-4.png'),
		name: "柳影人才公寓11栋2单元1304号",
		room: "一居室",
		size: "1458.22㎡",
		price: "3500"
	},
	{
		img: require('@/assets/image/housing/l-2.png'),
		name: "柳影人才公寓11栋2单元1304号",
		room: "一居室",
		size: "1458.22㎡",
		price: "3500"
	},
	{
		img: require('@/assets/image/housing/l-3.png'),
		name: "柳影人才公寓11栋2单元1304号",
		room: "一居室",
		size: "1458.22㎡",
		price: "3500"
	},
	// {
	// 	img: require('@/assets/image/housing/l-3.png'),
	// 	name: "柳影人才公寓11栋2单元1304号",
	// 	room: "一居室",
	// 	size: "1458.22㎡",
	// 	price: "3500"
	// },
	// {
	// 	img: require('@/assets/image/housing/l-3.png'),
	// 	name: "柳影人才公寓11栋2单元1304号",
	// 	room: "一居室",
	// 	size: "1458.22㎡",
	// 	price: "3500"
	// },
]

const matching = [{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	},
	{
		name: "家家乐超市(支农大街店)",
		text: "地址:汽车产业开发区支农大街博众新城二期",
		center: {
			lng: 125.227671,
			lat: 43.864869,
		},
	}
]

const list1 = [{
		img: require('@/assets/image/housing/l-1.png'),
		name: "柳影人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.306671,
			lat: 43.946118
		},
	},
	{
		img: require('@/assets/image/housing/l-2.png'),
		name: "基隆人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区基隆北街1823",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.288395,
			lat: 43.947048,
		},
	},
	{
		img: require('@/assets/image/housing/l-3.png'),
		name: "富丰人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市宽城区柳影家园",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.306671,
			lat: 43.946118
		},
	},
	{
		img: require('@/assets/image/housing/l-4.png'),
		name: "珍珠湖人才公寓",
		size: "1458.22㎡",
		area: "一居室",
		adress: "长春市绿园区基隆中街两侧",
		price: "3500",
		original: "4500",
		center: {
			lng: 125.262573,
			lat: 43.919844,
		},
	},
]


export {
	list,
	apartment,
	room,
	matching,
	list1
}
